import { inject, Injectable } from '@angular/core';
import { CAPICHE_LOGGER_CONFIG } from './capiche-logger.config';
import { CapicheLoggerCore } from '@capiche/ts-logger-core';

/**
 * LoggerService this service is used to log messages to the console.
 * each class that needs to log messages should create an instance of this service
 * logging is disabled in production
 *
 * CSW-720: this should probably be moved to /libs so it can be used by other apps in the workspace
 */

// ToDo: this should probably be made injectable
//@Injectable({ providedIn: 'root' })
export class CapicheLoggerService {
  private core: CapicheLoggerCore;

  constructor(prefix: string, enabled: boolean) {
    const config = inject(CAPICHE_LOGGER_CONFIG);
    const isProd = config.envName === 'production';

    this.core = new CapicheLoggerCore(prefix, !isProd && enabled);
  }

  // prettier-ignore
  verbose(...args: unknown[])  { this.core.verbose(...args); }
  // prettier-ignore  // prettier-ignore
  debug(...args: unknown[]) {
    this.core.debug(...args);
  }
  // prettier-ignore  // prettier-ignore
  info(...args: unknown[]) {
    this.core.info(...args);
  }
  // prettier-ignore
  log(...args: unknown[])   { this.core.log(...args); }
  // prettier-ignore
  warn(...args: unknown[])  { this.core.warn(...args); }
  // prettier-ignore
  error(...args: unknown[]) { this.core.error(...args); }
}
